<template>
  <div id="add-new-order-modal">
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="refundOrderModal"
        persistent
        max-width="530px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitForm()"
          >
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              ><span class="headline">Refund Order</span></v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  @click="closeRefundOrderModal(), $validator.reset()"
                  class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="checkAlert"
              >
                Order refunded successfully
              </v-alert>
              <v-layout wrap>
                <v-flex sm12>
                  <v-text-field
                    label="Refund Reason*"
                    v-model="refundData.refund_reason"
                    :error-messages="errors.collect('refund_reason')"
                    v-validate="'required'"
                    data-vv-name="refund_reason"
                  ></v-text-field>
                </v-flex>

                <v-flex sm12>
                  <v-text-field
                    label="Money amount*"
                    v-model="refundData.money_amount"
                    :error-messages="errors.collect('Money amount')"
                    v-validate="'required|decimal:2|between:0.1,' + orderRemainAmount"
                    data-vv-name="Money amount"
                  ></v-text-field>
                </v-flex>

                <v-flex sm12>
                  <v-text-field
                    label="Refund note"
                    v-model="refundData.refund_note"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-checkbox
                    style="padding: 0px"
                    label="Send SMS"
                    v-model="refundData.send_sms"
                    color="indigo"
                    hide-details
                  ></v-checkbox>
                </v-flex>

                <v-flex sm12>
                  <h5>Order Total amount is ${{theOrderTotalAmount}}</h5>
                </v-flex>

                <v-flex
                  v-if="refundData.partial_refunds && refundData.partial_refunds.length > 0"
                  xs12
                >
                  <h6>Partial Refunds</h6>
                  <ol>
                    <li
                      v-for="(obj, index) in refundData.partial_refunds"
                      :key="index"
                      style="font-size: 14px"
                    >
                      Amount ${{ obj.amount }} <span class="px-2">at {{ obj.created_at | moment('YYYY-MM-DD hh:mm A') }}</span> by {{ obj.user.full_name }}
                    </li>
                  </ol>
                </v-flex>

                <v-flex
                  v-if="refundData.partial_refunds && refundData.partial_refunds.length > 0"
                  sm12
                >
                  <h5>Order Total remain amount is ${{orderRemainAmount}}</h5>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeRefundOrderModal(), $validator.reset()"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto; margin-right: 4%"
                outline
                color="success"
              >Refund</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'refundOrderModal',
    'closeRefundOrderModal',
    'checkAlert',
    'refundData',
    'refundOrder',
    'loading',
    'theOrderTotalAmount'
  ],

  data() {
    return {
      loggedInUserData: {}
    }
  },

  computed: {
    orderRemainAmount() {
      if (this.refundData.partial_refunds && this.refundData.partial_refunds.length > 0) {
        let reAmount = 0
        this.refundData.partial_refunds.forEach(x => {
          reAmount += Number(x.amount)
        })

        return this.theOrderTotalAmount - reAmount
      }

      return this.theOrderTotalAmount
    }
  },

  mounted() {
    this.getLoggedInUser()
  },

  methods: {
    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.refundOrder()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/refundingOrder.vue